import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import { serverUrl } from "../utils/Constants";

const AdminDashboard = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const [view, setView] = useState("home");
  const [data, setData] = useState({});
  const [file, setFile] = useState(null);
  const [msg, setMsg] = useState("");

  //For deleting products
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  //For editing product
  const [editingProduct, setEditingProduct] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);

  const [activeButton, setActiveButton] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    uploadFiles();
  };

  function uploadData() {
    console.log(data);
    axios.post(`${serverUrl}/data-upload.php`, data).then((res) => {
      console.log(res.data);
      setMsg("Product Added");
      setTimeout(() => {
        setData({});
        setView("home");
      }, 1500);
    });
  }

  function uploadFiles() {
    if (!file) {
      setMsg("No File Selected");
    } else {
      const fd = new FormData();
      if (Number(data.img_count) === 1) {
        fd.append("file", file);
      } else {
        for (let i = 0; i < file.length; i++) {
          fd.append("files[]", file[i]);
        }
      }

      axios
        .post(`${serverUrl}/image-upload.php`, fd)
        .then((res) => {
          console.log(res.data);
          // setMsg(res.data);

          //Now upload data to database
          uploadData();
        })
        .catch((err) => setMsg(err));
    }
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setData((prevData) => ({ ...prevData, [name]: value }));
  };

  function handleDelete(id) {
    if (window.confirm("Are you sure you want to delete this product?")) {
      axios
        .delete(`${serverUrl}/data-delete.php?id=${id}`) // Replace with your API endpoint
        .then((response) => {
          if (response.data.status) {
            alert("Product deleted successfully.");
            setProducts(products.filter((product) => product.id !== id));
          } else {
            alert("Failed to delete product.");
          }
        })
        .catch((error) => {
          console.error("Error deleting product:", error);
          alert("An error occurred while deleting the product.");
        });
    }
  }

  const handleEdit = (product) => {
    setEditingProduct(product); // Set the product to be edited
    setShowEditModal(true); // Show the edit modal
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    if (editingProduct.product_type === "") editingProduct.product_type = "Walkers";

    axios
      .post(`${serverUrl}/data-update.php`, editingProduct)
      .then((response) => {
        if (response.data.status) {
          alert("Product updated successfully.");
          //   setProducts((prevProducts) => prevProducts.map((product) => (product.id === editingProduct.id ? editingProduct : product)));
          setShowEditModal(false);
        } else {
          alert("Failed to update product.");
        }
      })
      .catch((error) => {
        console.error("Error updating product:", error);
      });
  };

  //   // Fetch data from server
  //   useEffect(() => {
  //     axios
  //       .get(`http://localhost/server/get-data.php`) // Replace with your API endpoint
  //       //   .get(`http://localhost/server/get-data.php?productType=Walkers`) // Replace with your API endpoint
  //       .then((response) => {
  //         console.log(response.data);
  //         setProducts(response.data);
  //         setLoading(false);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching data:", error);
  //         setLoading(false);
  //       });
  //   }, []);

  async function fetchProductsByType(productType = null) {
    const typeOfProduct = productType ? `?productType=${encodeURIComponent(productType)}` : "";

    try {
      axios.get(`${serverUrl}/get-data.php${typeOfProduct}`).then((response) => {
        setProducts(response.data);
        setLoading(false);
      });
    } catch (error) {
      console.error("Error fetching products:", error);
      setLoading(false);
    }
  }

  const handleButtonClick = (buttonId) => {
    setActiveButton(buttonId);
  };

  // Render the content based on the selected view
  const renderContent = () => {
    switch (view) {
      case "addProduct":
        return (
          <div>
            <h3>Add Product</h3>
            <form onSubmit={handleSubmit} className="container mt-4">
              <div className="row mb-3">
                <label htmlFor="title" className="col-sm-3 col-form-label">
                  Title
                </label>
                <div className="col-sm-9">
                  <input type="text" className="form-control" id="title" name="title" onChange={handleChange} value={data.title || ""} />
                </div>
              </div>

              <div className="row mb-3">
                <label htmlFor="img_desc" className="col-sm-3 col-form-label">
                  Image Description
                </label>
                <div className="col-sm-9">
                  <input type="text" className="form-control" id="img_desc" name="img_desc" onChange={handleChange} value={data.img_desc || ""} />
                </div>
              </div>

              <div className="row mb-3">
                <label htmlFor="desc" className="col-sm-3 col-form-label">
                  Description
                </label>
                <div className="col-sm-9">
                  <textarea className="form-control" id="desc" name="desc" onChange={handleChange} value={data.desc || ""}></textarea>
                </div>
              </div>

              <div className="row mb-3">
                <label htmlFor="img_count" className="col-sm-3 col-form-label">
                  Image Count
                </label>
                <div className="col-sm-9">
                  <input
                    type="number"
                    className="form-control"
                    id="img_count"
                    name="img_count"
                    onChange={handleChange}
                    value={data.img_count || ""}
                  />
                </div>
              </div>

              <div className="row mb-3">
                <label htmlFor="productType" className="col-sm-3 col-form-label">
                  Product Type:
                </label>
                <select
                  id="productType"
                  name="productType"
                  className="col-sm-8 mx-3"
                  onChange={(e) => {
                    setData((prevData) => ({
                      ...prevData,
                      product_type: e.target.value,
                    }));
                  }}
                >
                  <option value="Walkers">Walkers</option>
                  <option value="Walking Sticks & Crutches">Walking Sticks & Crutches</option>
                  <option value="Commode Stool and Chairs">Commode Stool and Chairs</option>
                </select>
              </div>

              <div className="row mb-3">
                <label htmlFor="file_input" className="col-sm-3 col-form-label">
                  Upload File
                </label>
                <div className="col-sm-9">
                  <input
                    type="file"
                    className="form-control"
                    id="file_input"
                    name="img_name"
                    multiple={Number(data.img_count) > 1}
                    onChange={(e) => {
                      const files = Number(data.img_count) === 1 ? e.target.files[0] : e.target.files;
                      setFile(files);
                      setData((prevData) => ({
                        ...prevData,
                        img_src_name:
                          Number(data.img_count) === 1
                            ? files.name
                            : Array.from(files)
                                .map((file) => file.name)
                                .join(", "),
                      }));
                    }}
                  />
                </div>
              </div>

              <div className="d-flex justify-content-end">
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
              <p>{msg}</p>
            </form>
          </div>
        );

      case "deleteProduct":
        return (
          <div className="container mt-3 text-center">
            <h2 className="mb-5">Delete Product</h2>
            <label htmlFor="productTypeFilter" className="mb-5">
              Filter by Product Type:
            </label>
            <select
              id="productTypeFilter"
              className="mx-3"
              onChange={(e) => {
                fetchProductsByType(e.target.value);
              }}
            >
              <option value="">All</option>
              <option value="Walkers">Walkers</option>
              <option value="Walking Sticks & Crutches">Walking Sticks & Crutches</option>
              <option value="Commode Stool and Chairs">Commode Stool and Chairs</option>
            </select>

            {loading ? (
              <p>Loading...</p>
            ) : products.length === 0 ? (
              <p>No products found.</p>
            ) : (
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Title</th>
                    <th>Img-Desc</th>
                    <th>Desc</th>
                    <th>Imgs</th>
                    <th>Product-Type</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {products.map((product, i) => (
                    <tr key={product.id}>
                      <td>{i}</td>
                      <td>{product.title}</td>
                      <td>{product.img_desc}</td>
                      <td>{product.desc.join(", ")}</td>
                      <td>{Array.isArray(product.img_src_name) ? product.img_src_name.join(", ") : product.img_src_name}</td>
                      <td>{product.product_type}</td>
                      <td>
                        <button className="btn btn-warning" onClick={() => handleEdit(product)}>
                          Edit
                        </button>
                        <button className="btn btn-danger" onClick={() => handleDelete(product.id)}>
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        );

      case "home":
      default:
        return <h3>Welcome to the Admin Dashboard</h3>;
    }
  };

  return (
    <div className="container-fluid">
      <div className="row">
        {/* Sidebar */}
        <div className="col-md-2 bg-dark text-white p-3" style={{ minHeight: "100vh" }}>
          <h4>Admin Panel</h4>
          <ul className="nav flex-column">
            <li className="nav-item">
              <button
                className={`btn text-white text-start w-100 ${activeButton === 1 ? "text-decoration-underline" : ""} ${
                  activeButton === 1 ? "text-decoration-underline" : ""
                }`}
                onClick={() => {
                  handleButtonClick(1);
                  setView("home");
                }}
              >
                Home
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`btn text-white text-start w-100 ${activeButton === 2 ? "text-decoration-underline" : ""}`}
                onClick={() => {
                  handleButtonClick(2);
                  setView("addProduct");
                  setData((prevData) => ({
                    ...prevData,
                    product_type: "Walkers",
                  }));
                }}
              >
                Add Product
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`btn text-white text-start w-100 ${activeButton === 3 ? "text-decoration-underline" : ""}`}
                onClick={() => {
                  handleButtonClick(3);
                  setView("deleteProduct");
                  fetchProductsByType();
                }}
              >
                Edit / Delete Product
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`btn text-white text-start w-100 ${activeButton === 4 ? "text-decoration-underline" : ""}`}
                onClick={() => {
                  handleButtonClick(4);
                  logout();
                  navigate("/admin");
                }}
              >
                Logout
              </button>
            </li>
          </ul>
        </div>

        {/* Main Content */}
        <div className="col-md-10 p-4">{renderContent()}</div>
        {/* Edit Modal */}
        {showEditModal && (
          <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Product</h5>
                  <button type="button" className="btn-close" onClick={() => setShowEditModal(false)}></button>
                </div>
                <div className="modal-body">
                  {/* Edit Form */}
                  <form onSubmit={(e) => handleUpdate(e)}>
                    <div className="mb-3">
                      <label htmlFor="title" className="form-label">
                        Title
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="title"
                        value={editingProduct?.title || ""}
                        onChange={(e) =>
                          setEditingProduct((prev) => ({
                            ...prev,
                            title: e.target.value,
                          }))
                        }
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="description" className="form-label">
                        Img-Desc
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="img-desc"
                        value={editingProduct?.img_desc || ""}
                        onChange={(e) =>
                          setEditingProduct((prev) => ({
                            ...prev,
                            img_desc: e.target.value,
                          }))
                        }
                      ></input>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="price" className="form-label">
                        Desc
                      </label>
                      <textarea
                        className="form-control"
                        id="desc"
                        value={editingProduct?.desc || ""}
                        onChange={(e) =>
                          setEditingProduct((prev) => ({
                            ...prev,
                            desc: JSON.stringify([e.target.value]),
                          }))
                        }
                      />
                    </div>

                    <div className="row mb-3">
                      <label htmlFor="productType" className="col-sm-3 col-form-label">
                        Product Type:
                      </label>

                      <select
                        id="productType"
                        name="productType"
                        className="col-sm-8 mx-3"
                        value={editingProduct?.product_type || ""}
                        onChange={(e) => {
                          setEditingProduct((prevData) => ({
                            ...prevData,
                            product_type: e.target.value,
                          }));
                        }}
                      >
                        <option value="Walkers">Walkers</option>
                        <option value="Walking Sticks & Crutches">Walking Sticks & Crutches</option>
                        <option value="Commode Stool and Chairs">Commode Stool and Chairs</option>
                      </select>
                    </div>

                    <button type="submit" className="btn btn-primary">
                      Save Changes
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDashboard;
